import React from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import './GenreFilter.css';

const GenreFilter = ({
  isOpen,
  toggle,
  targetId,
  genres,
  selectedGenres,
  onGenreToggle,
  onClear,
}) => {
  return (
    <Popover
      target={targetId}
      isOpen={isOpen}
      toggle={toggle}
      placement="bottom-end"
      popperClassName="genre-filter-popover"
      trigger="legacy"
    >
      <PopoverBody>
        <div className="genre-filter-header">
          <h3 className="genre-filter-title">Filter by Genre</h3>
          {selectedGenres.size > 0 && onClear && (
            <button
              type="button"
              className="genre-filter-clear"
              onClick={onClear}
            >
              Clear
            </button>
          )}
        </div>

        <div className="genre-filter-list">
          {genres.length === 0 ? (
            <p className="genre-filter-empty">No genres available</p>
          ) : (
            genres.map(genre => (
              <button
                key={genre}
                className={`genre-filter-item ${
                  selectedGenres.has(genre) ? 'active' : ''
                }`}
                onClick={() => onGenreToggle(genre)}
              >
                <span className="genre-filter-item-text">{genre}</span>
                {selectedGenres.has(genre) && (
                  <svg
                    className="genre-filter-check"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
            ))
          )}
        </div>

        <div className="genre-filter-footer">
          <p className="genre-filter-count">
            {selectedGenres.size === 0
              ? 'Select genres to filter'
              : `${selectedGenres.size} genre${selectedGenres.size > 1 ? 's' : ''} selected`
            }
          </p>
        </div>
      </PopoverBody>
    </Popover>
  );
};

export default GenreFilter;
